import CatgeoryBanner from "@/components/category/banner/banner";
import CatgeoryFilters from "@/components/category/filters/filters";
import CategoryProductsList from "@/components/category/products-list/products-list";
import PageNotFound from "@/components/common/page-not-found/page-not-found";
import Layout from "@/layout/layout";
import { useAppDispatch, wrapper } from "@/store";
import { authActions, selectAuth } from "@/store/slices/auth";
import {
  fetchCategoryBySlug,
  fetchCategoryProductsById,
  selectCategory,
} from "@/store/slices/category";
import {
  selectHelmet,
  setIgnoreCommonTitle,
  setMeta,
  setOg,
  setPath,
  setSchemas,
  setTitle,
} from "@/store/slices/helmet";
import styles from "@/styles/product_list.module.scss";
import Script from "next/script";
import React, { ReactElement, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
import CatgeoryFiltersWizzy from "@/components/category-wizzy/filters/filters";
import CategoryProductsListWizzy from "@/components/category-wizzy/products-list/products-list";
import { syteTrackEvent } from "@/lib/syte";
import CatgeoryFiltersUnbxd from "@/components/category-unbxd/filters/filters";
import CategoryProductsListUnbxd from "@/components/category-unbxd/products-list/products-list";
import CatgeoryBreadcrumb from "@/components/category-unbxd/breadcrumb/breadcrumb";

const Category = () => {
  const categoryState = useSelector(selectCategory);
  const helmetState = useSelector(selectHelmet);
  const dispatch = useAppDispatch();
  const authState = useSelector(selectAuth);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (
        !authState.isModalOpen &&
        categoryState.data?.slug === "satya-prem-ki-katha"
      ) {
        moment.tz.setDefault("Asia/Kolkata");
        const currentDate = moment();
        const endDate = moment("2023-06-28", "YYYY-MM-DD").endOf("day");
        if (currentDate.isSameOrBefore(endDate)) {
          dispatch(authActions.setIsOfferModalOpen(true));
        }
      }
    }, 6000);
    if (!authState.isUserLoading) {
      syteTrackEvent({
        name: "fe_page_view",
        tag: "ecommerce",
        osh_id: authState.user?.uuid,
      });
    }

    return () => clearTimeout(timer);
  }, [
    authState.isModalOpen,
    authState.isUserLoading,
    authState.user?.uuid,
    categoryState.data?.slug,
    dispatch,
  ]);

  return (
    <>
      <CatgeoryBanner />
      <div className={styles.heading_list_page}>
        <div className={`${styles.container} ${"container"}`}>
          <div className="row mb-0 mt-2">
            <div className="col-12">
              <CatgeoryBreadcrumb />
            </div>
          </div>
          <h1 className="">
            {categoryState.data?.title}

            {categoryState.data?.title && (
              <span
                style={{
                  color: "#7f7f7f",
                }}
              ></span>
            )}
            {!!categoryState.products?.response?.numberOfProducts && (
              <small
                className={styles.avilable}
                style={{
                  color: "#7f7f7f",
                }}
              >
                ({categoryState.products?.response?.numberOfProducts} Designs )
              </small>
            )}
          </h1>
        </div>
      </div>
      <section className={styles.product_section}>
        {/* <CatgeoryFilters />
        <CategoryProductsList /> */}
        {/* <CatgeoryFiltersWizzy />
        <CategoryProductsListWizzy /> */}
        <CatgeoryFiltersUnbxd />
        <CategoryProductsListUnbxd />
      </section>
    </>
  );
};

Category.getLayout = (page: ReactElement) => {
  return <Layout>{page}</Layout>;
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ params, resolvedUrl }) => {
      if (!params?.category) {
        return { notFound: true };
      }
      store.dispatch(setPath(resolvedUrl));
      const { payload: category } = await store.dispatch(
        fetchCategoryBySlug(params.category as string)
      );

      if (!category) {
        return { notFound: true };
      }

      const { payload: list } = await store.dispatch(
        fetchCategoryProductsById({ id: category.id })
      );

      store.dispatch(
        setTitle(category.meta_title || category.title || category.name)
      );
      store.dispatch(
        setMeta({
          title: category.meta_title || category.title || category.name,
          description: category?.meta_description,
          keywords: category.meta_keywords,
        })
      );
      store.dispatch(
        setOg({
          type: "website",
          url: `${process.env.NEXT_PUBLIC_APP_URL}${resolvedUrl}`,
          title: category.meta_title || category.title || category.name,
          description: category?.meta_description,
          image: category.banner_image,
        })
      );
      if (category.meta_title) store.dispatch(setIgnoreCommonTitle(true));

      const existingSchemas = [
        JSON.stringify({
          "@context": "http://schema.org/",
          "@type": "ItemList",
          "@category": category.name,
          "@keywords": category.meta_keywords,
          "@count": list?.totalRecords || 0,
          itemListElement: (list?.data || []).map((product: any, index: number) => ({
            "@type": "ListItem",
            position: index + 1,
            url: `${process.env.NEXT_PUBLIC_APP_URL}/jewellery/${product.slug}`,
          })),
        }),
      ];

      if (category.schema) {
        existingSchemas.push(
          typeof category.schema === "string"
            ? category.schema
            : JSON.stringify(category.schema)
        );
      }

      const metaTitle = category?.meta_title || category?.title || category?.name || "";
      const metaDescription = category?.meta_description || "";
      const h1Text = category?.title || category?.name || "";

      const speakableSchemaObj = {
        "@context": "https://schema.org",
        "@type": "SpeakableSpecification",
        "cssSelector": [
          `"metaTitle": "${metaTitle}"`,
          `"metaDescription": "${metaDescription}"`,
          `"H1": "${h1Text}"`,
        ],
      };

      const speakableSchemaStr = JSON.stringify(speakableSchemaObj);

      store.dispatch(setSchemas([...existingSchemas, speakableSchemaStr]));

      return {
        props: {},
      };
    }
);

export default Category;
